export default __webpack_public_path__ + "static/color-picker-role-do-81d003e275e02917803757b7039e415a.png";